import { useCareersForm } from "../../hooks/useCareersForm";

const CarrersForm: React.FC = () => {
  const {
    register,
    handleSubmit,
    errors,
    isValid,
    inputRef,
    formRef,
    selectedFile,
    fileError,
    progress,
    isLoading,
    handleFileInput,
    handleDrop,
    handleDragOver,
    onSubmit,
    getInputClass,
  } = useCareersForm();

  return (
    <div className="w-full mx-auto bg-white">
      <div className="text-black bg-white">
        {isLoading && (
          <div className="w-full flex items-center justify-center py-8">
            <div className="h-10 w-10 rounded-full border-4 border-black border-t-transparent animate-spin" />
            <span className="ml-3">Subiendo… {progress}%</span>
          </div>
        )}

        <form
          ref={formRef}
          onSubmit={handleSubmit(onSubmit)}
          className="w-full max-w-4xl mx-auto"
          id="careers-form"
        >
          <div className="grid grid-cols-2 gap-8 mb-6">
            <div className="block w-full">
              <label className="block text-left text-sm font-medium mb-2">
                Nombres <span className="text-[#d93a34]">*</span>
              </label>
              <input
                {...register("names")}
                className={`w-full px-3 py-2 border-b border-black focus:outline-none focus:ring-0 ${getInputClass(
                  "names"
                )}`}
                type="text"
                placeholder="Emely"
              />
              {errors.names && (
                <p className="text-left text-red-500 text-xs mt-1">
                  {errors.names.message}
                </p>
              )}
            </div>

            <div className="block w-full">
              <label className="block text-left text-sm font-medium mb-2">
                Apellidos <span className="text-[#d93a34]">*</span>
              </label>
              <input
                {...register("lastNames")}
                className={`w-full px-3 py-2 border-b border-black focus:outline-none focus:ring-0 ${getInputClass(
                  "lastNames"
                )}`}
                type="text"
                placeholder="Sánchez De León"
              />
              {errors.lastNames && (
                <p className="text-left text-red-500 text-xs mt-1">
                  {errors.lastNames.message}
                </p>
              )}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 mb-6">
            <div className="w-full">
              <label className="block text-left text-sm font-medium mb-2">
                Correo Electrónico <span className="text-[#d93a34]">*</span>
              </label>
              <input
                {...register("email")}
                className={`w-full px-3 py-2 border-b border-black focus:outline-none focus:ring-0 ${getInputClass(
                  "email"
                )}`}
                type="email"
                placeholder="emely.sanchez@penadefillo.com"
              />
              {errors.email && (
                <p className="text-left text-red-500 text-xs mt-1">
                  {errors.email.message}
                </p>
              )}
            </div>

            <div className="w-full">
              <label className="block text-left text-sm font-medium mb-2">
                Número Telefónico <span className="text-[#d93a34]">*</span>
              </label>
              <input
                {...register("phone")}
                className={`w-full px-3 py-2 border-b border-black focus:outline-none focus:ring-0 ${getInputClass(
                  "phone"
                )}`}
                type="tel"
                placeholder="+1 (829) 555-0000"
              />
              {errors.phone && (
                <p className="text-left text-red-500 text-xs mt-1">
                  {errors.phone.message}
                </p>
              )}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 mb-6">
            <div className="w-full">
              <label className="block text-left text-sm font-medium mb-2">
                Dirección
              </label>
              <input
                {...register("direction")}
                className={`w-full px-3 py-2 border-b border-black focus:outline-none focus:ring-0 ${getInputClass(
                  "direction"
                )}`}
                type="text"
                placeholder="Av. Gustavo Mejía Ricart 54, Santo Domingo"
              />
              {errors.direction && (
                <p className="text-left text-red-500 text-xs mt-1">
                  {errors.direction.message}
                </p>
              )}
            </div>

            <div className="w-full">
              <label className="block text-left text-sm font-medium mb-2">
                Resume/CV <span className="text-[#d93a34]">*</span>
              </label>
              {/* Input oculto real */}
              <input
                ref={inputRef}
                className="hidden"
                type="file"
                accept=".pdf,.doc,.docx,.txt,.rtf"
                onChange={handleFileInput}
              />
              {/* Línea de acciones como en el diseño */}
              <div
                className="select-none text-left"
                onDrop={handleDrop}
                onDragOver={handleDragOver}
              >
                <span
                  className="text-[#0942B0] font-medium cursor-pointer"
                  onClick={() => inputRef.current?.click()}
                >
                  Adjuntar
                </span>
                <span className="mx-1">,</span>
                <span
                  className="underline cursor-pointer"
                  onClick={() => inputRef.current?.click()}
                >
                  Dropbox
                </span>
                <span className="mx-1">o</span>
                <span
                  className="text-[#0942B0] font-medium cursor-pointer"
                  onClick={() => inputRef.current?.click()}
                >
                  soltar aquí
                </span>
                <p className="text-sm text-gray-400 mt-2">
                  Tipos de archivos permitidos: pdf, doc, docx, txt, rtf
                </p>
              </div>
              {selectedFile && (
                <p className="text-sm text-left text-green-600 mt-2">
                  Archivo seleccionado: {selectedFile.name}
                </p>
              )}
              {progress > 0 && (
                <div className="mt-4">
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div
                      className="bg-blue-600 h-2 rounded-full"
                      style={{ width: `${progress}%` }}
                    ></div>
                  </div>
                  <p className="text-sm text-gray-600 mt-1">{progress}%</p>
                </div>
              )}
            </div>
            {fileError && (
              <p className="text-left text-red-500 text-xs mt-2">{fileError}</p>
            )}
          </div>

          <div className="w-full my-16">
            <hr className="max-w-5xl mx-auto bg-[#6E6E6E]" />
          </div>

          <div className="grid grid-cols-2 gap-8 mb-6">
            <div className="block w-full">
              <label className="block text-left text-sm font-medium mb-2">
                Perfil de LinkedIn <span className="text-[#d93a34]">*</span>
              </label>
              <input
                {...register("linkedin")}
                className={`w-full px-3 py-2 border-b border-black focus:outline-none focus:ring-0 ${getInputClass(
                  "linkedin"
                )}`}
                type="text"
                placeholder="https://www.linkedin.com/in/emelysanchezdl/"
              />
              {errors.linkedin && (
                <p className="text-left text-red-500 text-xs mt-1">
                  {errors.linkedin.message}
                </p>
              )}
            </div>

            <div className="block w-full">
              <label className="block text-left text-sm font-medium mb-2">
                Página Web/Portafolio
              </label>
              <input
                {...register("portfolio")}
                className={`w-full px-3 py-2 border-b border-black focus:outline-none focus:ring-0 ${getInputClass(
                  "portfolio"
                )}`}
                type="text"
                placeholder="https://tu-portafolio.com"
              />
              {errors.portfolio && (
                <p className="text-left text-red-500 text-xs mt-1">
                  {errors.portfolio.message}
                </p>
              )}
            </div>
          </div>

          <div className="w-full flex justify-end">
            <button
              type="submit"
              disabled={!isValid || isLoading}
              className="w-48 h-12 bg-black text-white font-medium text-sm leading-5 tracking-wider transition-colors duration-200 cursor-pointer hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-black"
            >
              {isLoading ? "Enviando..." : "Enviar aplicación"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CarrersForm;
